import React, {Component} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import Expand from "react-expand-animated";
import {withAlert} from 'react-alert';
import {postRequest} from "../routes/Routes";
import {addToCartFormSubmit} from "../common/Common";
import '../assets/css/Home.css';

class Category extends Component {
    constructor(props) {
        super(props);
        this.state = {products: []};
    }

    componentDidMount() {
        if (this.props.products) {
            this.setState({products: this.props.products});
        } else {
            this.loadProducts();
        }
    }

    render() {
        return (
            !this.props.products ?
                <div className="container category-list partner-list">
                    <h1 className="heading capital-text">
                        {this.props.match.params.categoryName ?
                            this.props.match.params.categoryName :
                            this.props.match.params.partnerName} Products
                    </h1>
                    <hr/>
                    {this.getProductBody()}
                </div>
                : this.getProductBody()
        );
    }

    getProductBody = () => {
        let firstColumn = [];
        let secondColumn = [];
        let thirdColumn = [];
        this.state.products.forEach((product, index) => {
            if ((index + 1) % 3 === 0) {
                thirdColumn.push(this.getProductCode(product, index))
            } else if ((index + 1) % 2 === 0) {
                secondColumn.push(this.getProductCode(product, index))
            } else {
                firstColumn.push(this.getProductCode(product, index))
            }
        });

        return (
            <div className="d-flex bd-highlight w-100">
                <div className="p-2 flex-fill bd-highlight">
                    {firstColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {secondColumn}
                </div>
                <div className="p-2 flex-fill bd-highlight">
                    {thirdColumn}
                </div>
            </div>
        );
    };

    getProductCode = (product, index) => {
        return (
            <div key={index}>
                <div className={"category-item" + (product.open ? " order" : "")}
                     onClick={() => this.expandProduct(index)}>
                    <img src={product.product_images.length > 0 ? product.product_images[0].image_url : null}
                         alt={product.name}/>
                    <div className="category-item-name">
                        <div className="d-flex bd-highlight w-100">
                            <div className="p-2 flex-fill bd-highlight">
                                <h5>{product.name}</h5>
                            </div>
                            <div className="p-2 flex-fill bd-highlight">
                                <div>Price: <strong>Rs.{product.price}</strong></div>
                            </div>
                        </div>
                    </div>
                </div>
                <Expand open={product.open} className="add-product-cart-form">
                    Items Remaining: <strong>{product.stock} items</strong>
                    <form className="d-flex bd-highlight w-100" onSubmit={this.formSubmit}>
                        <input className="form-control" type="text" id="id" defaultValue={product.id} hidden/>
                        <input className="form-control" type="text" id="name" defaultValue={product.name} hidden/>
                        <input className="form-control" type="number" id="stock" defaultValue={product.stock} hidden/>
                        <input className="form-control" type="number" id="price" defaultValue={product.price} hidden/>
                        <div className="p-2 flex-fill bd-highlight">
                            <div className="form-inline">
                                <label htmlFor="quantity" className="quantity-label">Quantity:</label>
                                <input className="form-control" type="number" placeholder='Quantity*' id="quantity"
                                       min="1" max={product.stock} defaultValue="1" required/>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight action-div">
                            <button type="submit" className="btn blue-button login-button w-100"
                                    disabled={product.stock <= 0}>
                                {product.stock > 0 ? "Add to Cart" : "Out of Stock"}
                            </button>
                        </div>
                    </form>
                    <NavLink className="nav-link" to={"/product/" + product.id}>
                        <button className="btn blue-border-button login-button">More Details</button>
                    </NavLink>
                </Expand>
            </div>
        );
    };

    loadProducts = () => {
        let {products} = this.state;
        postRequest({
            name: this.props.match.params.categoryName ? this.props.match.params.categoryName : this.props.match.params.partnerName,
            endpoint: this.props.match.params.categoryName ? '/api/categories/products' : '/api/partners/products'
        }).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    response.data.products.forEach((product) => {
                        product.open = false;
                        products.push(product);
                    });
                }
                this.setState({products: products});
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    expandProduct = (index) => {
        let {products} = this.state;
        products[index].open = !products[index].open;
        this.setState({products: products});
    };

    formSubmit = (event) => {
        event.preventDefault();
        addToCartFormSubmit(event, this.props.alert);
    }
}

export default withAlert()(withRouter(Category));